module.exports = __webpack_public_path__ + "img/mcp_logo_240_2.5c4aa7c0.webp";